var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('a-row',{staticStyle:{"justify-content":"center"},attrs:{"type":"flex"}},[_c('a-col',{staticClass:"footer-control",attrs:{"span":24,"sm":16,"md":16,"xl":12}},[_c('p',{staticClass:"copyright"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }